import type { NavItemLink } from "@wayflyer/flyui";
import { IconMoneyCheck20Line } from "@wayflyer/flyui-icons/20/line";
import { useIntl } from "react-intl";

import { BILLS_NAV_ITEM_ID } from "./nav-layout";

export function useBillsNavigationItem({
  customerDomain,
  billsEnabled,
}: {
  customerDomain: string;
  billsEnabled: boolean;
}): NavItemLink | undefined {
  const intl = useIntl();

  if (!billsEnabled || !customerDomain) {
    return;
  }

  return {
    id: BILLS_NAV_ITEM_ID,
    label: intl.formatMessage({
      id: "bills navigation item",
      defaultMessage: "Bills",
    }),
    href: `/${customerDomain}/bills`,
    icon: <IconMoneyCheck20Line />,
  };
}
